import {
  Button,
  createStyles,
  IconButton,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  onAcceptPendingRequest,
  selectPendingRequest,
} from "../../../redux/actions/types/pendingRequestTypes";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: "#6AAF52",
    },
  })
);

type AcceptButtonProps = {
  rowData: any;
  isMobile?: boolean;
};

const AcceptButton = ({ rowData, isMobile }: AcceptButtonProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t, BundleKey } = useTranslation();

  const onClickAccept = () => {
    dispatch(onAcceptPendingRequest(true));
    dispatch(selectPendingRequest(rowData));
  };

  return (
    <Tooltip title={t(BundleKey.ACTION_APPROVE).toString()}>
      {isMobile ? (
        <Button size="small" onClick={onClickAccept} className={classes.root}>
          {t(BundleKey.ACTION_ACCEPT)}
        </Button>
      ) : (
        <IconButton
          aria-label="reject"
          onClick={onClickAccept}
          className={classes.root}
        >
          <CheckCircleIcon fontSize="large" />
        </IconButton>
      )}
    </Tooltip>
  );
};

export default AcceptButton;
